import React from 'react';
import { Button } from 'react-bootstrap';
import { getFrontSheet } from '../../services/documentDownloadService';

type CreateFrontSheetButtonProps = {
  reportId: number;
  onBeforeClick?: () => Promise<void>;
  className?: string;
}

export default function CreateFrontSheetButton(props: CreateFrontSheetButtonProps) {
  const { reportId, onBeforeClick, className } = props;

  async function onClick() {
    if (onBeforeClick)
      await onBeforeClick();

    getFrontSheet(reportId);
  }

  return (
    <Button
      variant='secondary'
      size='sm'
      onClick={onClick}
      className={className}
    >
      Create Front Sheet
    </Button>
  )
}